import flowRight from 'lodash/flowRight'
import { connect } from 'react-redux'

import { withLivedata, withUserConfig } from 'shared'
//@ts-ignore
import withAuthorized from 'shared/containers/withAuthorized'
import { getCommercialRate, getCommercialRate2, getOfficialRate, getOfficialRate2 } from './selectors'

export default flowRight(
  withAuthorized,
  withUserConfig([
    'NodeTitle as nodeTitle',
    'LoginFull as username',
    'ForeignCCY as foreignCCY',
    'ForeignCCY2 as foreignCCY2',
    'LocalCCY as localCCY',
  ]),
  withLivedata([
    'OpenDayStatus.Open_Day_Str as operationalDay',
    'OpenDayStatus.Cur_Date as currentDate',
    'CCYOfficalRates as officialRates',
    'CCYCommercialRates as commercialRates',
    'OpenDayStatus.Locked as locked',
  ]),
  connect((state, ownProps) => ({
    //@ts-ignore
    officialRate: getOfficialRate(state, ownProps),
    //@ts-ignore
    officialRate2: getOfficialRate2(state, ownProps),
    //@ts-ignore
    commercialRate: getCommercialRate(state, ownProps),
    //@ts-ignore
    commercialRate2: getCommercialRate2(state, ownProps),
  })),
)
